// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Finterfaces%2Fsrc%2Fworkflow-model-schema.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { ItemCardinality, ItemRole } from '../../workflow-model-schema';
import { validateArray } from '@augloop/validator-common';
export class WorkflowModelItemSchemaValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowModelItemSchema: Expected object, got undefined object for WorkflowModelItemSchemaValidator' };
        }
        if ((obj.name !== undefined) && (typeof obj.name !== 'string')) {
            return { success: false, error: 'WorkflowModelItemSchema: Optional field "name" is wrong type' };
        }
        if (obj.type === undefined) {
            return { success: false, error: 'WorkflowModelItemSchema: Required field "type" is missing' };
        }
        else if (typeof obj.type !== 'string') {
            return { success: false, error: 'WorkflowModelItemSchema: Required field "type" is wrong type' };
        }
        if ((obj.deltaType !== undefined) && (typeof obj.deltaType !== 'string')) {
            return { success: false, error: 'WorkflowModelItemSchema: Optional field "deltaType" is wrong type' };
        }
        if (obj.role === undefined) {
            return { success: false, error: 'WorkflowModelItemSchema: Required field "role" is missing' };
        }
        else {
            const result = itemRoleValidatorInstance.validate(obj.role);
            if (!result.success) {
                result.error = "WorkflowModelItemSchema.role: " + result.error;
                return result;
            }
        }
        if ((obj.cardinality !== undefined)) {
            const result = itemCardinalityValidatorInstance.validate(obj.cardinality);
            if (!result.success) {
                result.error = "WorkflowModelItemSchema.cardinality: " + result.error;
                return result;
            }
        }
        if ((obj.noBody !== undefined) && (typeof obj.noBody !== 'boolean')) {
            return { success: false, error: 'WorkflowModelItemSchema: Optional field "noBody" is wrong type' };
        }
        if ((obj.noInvalidation !== undefined) && (typeof obj.noInvalidation !== 'boolean')) {
            return { success: false, error: 'WorkflowModelItemSchema: Optional field "noInvalidation" is wrong type' };
        }
        if ((obj.asyncBoundary !== undefined) && (typeof obj.asyncBoundary !== 'boolean')) {
            return { success: false, error: 'WorkflowModelItemSchema: Optional field "asyncBoundary" is wrong type' };
        }
        if (obj.children !== undefined) {
            const result = validateArray(obj.children, 1, workflowModelItemSchemaValidatorInstance, '{WorkflowModelItemSchema}');
            if (!result.success) {
                result.error = "WorkflowModelItemSchema.children: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const workflowModelItemSchemaValidatorInstance = new WorkflowModelItemSchemaValidator();
export class ItemRoleValidator {
    validate(value) {
        if (!ItemRoleValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "ItemRole"' };
        }
        return { success: true };
    }
}
ItemRoleValidator.validValues = new Set([ItemRole.Input, ItemRole.Output]);
export const itemRoleValidatorInstance = new ItemRoleValidator();
export class ItemCardinalityValidator {
    validate(value) {
        if (!ItemCardinalityValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "ItemCardinality"' };
        }
        return { success: true };
    }
}
ItemCardinalityValidator.validValues = new Set([ItemCardinality.Single, ItemCardinality.Any, ItemCardinality.Optional, ItemCardinality.Some]);
export const itemCardinalityValidatorInstance = new ItemCardinalityValidator();
//# sourceMappingURL=workflow-model-schema-validator.g.js.map